import './component.scss'
import { Controller } from 'stimulus'
import { debounce } from 'Packs/src/site/components/utils/debounce'

window.Stimulus.register(
  'nurikae-site-pages-examples-index-pc-partials-reform-example-card',
  class extends Controller {
  static targets = ["text", "textContent", "moreButton"]

  connect() {
    this._initializeTextToggle()
    const debouncedInit = debounce(() => {
      this._initializeTextToggle()
    }, 200)
    this._resizeObserver = new ResizeObserver(debouncedInit)
    this._resizeObserver.observe(this.element)
  }

  disconnect() {
    if (this._resizeObserver) {
      this._resizeObserver.disconnect()
    }
  }

  clickMoreButton(event) {
    event.stopPropagation()
    const card = this.element.closest('.reform-example-card-pc')
    window.location.href = card.href
  }

  _initializeTextToggle() {
    // line-clampを一時的に解除してテキストの高さを測定
    this.textTarget.style.webkitLineClamp = 'none'
    this.textTarget.style.lineClamp = 'none'
    this.textTarget.style.overflow = 'visible'

    requestAnimationFrame(() => {
      const HEIGHT_TOLERANCE = 5
      const fullHeight = this.textTarget.scrollHeight

      // line-clampを復元
      this.textTarget.style.webkitLineClamp = '3'
      this.textTarget.style.lineClamp = '3'
      this.textTarget.style.overflow = 'hidden'

      const clampedHeight = this.textTarget.offsetHeight

      // 3行より多い場合は「もっと見る」ボタンを表示、それ以外は非表示
      if (fullHeight > clampedHeight + HEIGHT_TOLERANCE) {
        this.moreButtonTarget.classList.remove('hidden')
      } else {
        this.moreButtonTarget.classList.add('hidden')
      }
    })
  }
}
)
